import {AssetsQaRequestParams} from "../../infrastructure/models/params/assets-qa-request-params";

export class PointsDeductionsHammerRequestParams extends AssetsQaRequestParams {
  constructor(width: Number, height: Number) {
    super(width, height);

    this.resourceName = `${this.resourceName}/Standings/Hammer`;
  }
}
